/**
 * Directive: search
 */
angular.module('acme.view.application.orders.modals.privateEvent.directive.eventDate', [
  'acme.common.directive.dateFieldWithLabel',
  'acme.common.directive.textareaFieldWithLabel',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])
.directive('eventDate', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'views/application/views/orders/modals/privateEvent/eventDate.tpl.html',
      scope: {
        model: '=',
        currentDateTime: '=',
        privateSchedule: '=',
        privateScheduleTime: '=',
        privateScheduleTimes: '=',
        privateDuration: '=',
        timesTab: '=',
        errors: '=privateErrors'
      },

      controller: ['$scope', '$filter', 'CalendarService', 'UserPreferencesService', function($scope, $filter, CalendarService, UserPreferencesService) {

        $scope.eventDate = {
          model: '',

          hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

          init: function() {
            this.initDate();

            $scope.$watch('privateScheduleTime', function(n,o) {
              if (n !== o) {
                $scope.eventDate.privateScheduleTime = $scope.privateScheduleTime;
              }
            });
          },

          initDate: function() {
            var self = $scope.eventDate,
                isPrivate = false,
                currentDateTime = moment(),
                currentDateTimeName = '';

            if ($scope.currentDateTime) {
              currentDateTimeName = $filter('date')(CalendarService.parseDate($scope.currentDateTime), this.hourFormat);

              if (this.hasPrivateSchedulesTimes) {
                $scope.privateScheduleTimes.forEach(function(item) {
                  if (currentDateTimeName === item.name) {
                    isPrivate = true;
                    $scope.privateScheduleTime = item;
                  }
                });

                if (!isPrivate) {
                  $scope.timesTab = 'standard';
                  currentDateTime = moment($scope.currentDateTime);
                  $scope.model.timeHr = currentDateTime.format('hh');
                  $scope.model.timeMin = currentDateTime.format('mm');
                  $scope.model.timeAm = (currentDateTime.format('a') === 'am');
                }
              }
            }

            $scope.eventDate.privateScheduleTime = $scope.privateScheduleTime;
          },

          hasPrivateSchedulesTimes: function () {
            return ($scope.privateSchedule.hasOwnProperty('hours') && $scope.privateSchedule.hours.length);
          },

          isActiveTab: function(type) {
            return (type === $scope.timesTab);
          },

          setTab: function(type) {
            $scope.timesTab = type;
          },

          changeAMPM: function() {
              $scope.model.timeAm = !$scope.model.timeAm;
          },

          checkDuration: function() {
            return (
              Number($scope.model.durationHr) !== $scope.privateDuration.hour ||
              Number($scope.model.durationMin) !== $scope.privateDuration.minutes
            );
          },

          undoDuration: function() {
            var duration = angular.copy($scope.privateDuration);

            $scope.model.durationHr = (duration.hour || (!duration.hour && duration.minutes)) ? duration.hour : 1;
            $scope.model.durationMin = duration.minutes || 0;
          },

          onPrivateScheduleTimeChange: function() {
            $scope.privateScheduleTime = $scope.eventDate.privateScheduleTime;
          }
        };

        $scope.eventDate.init();
      }]

    };

}]);
